export default {"src":"/_next/static/media/feedback.40667ca9.svg","height":513,"width":513};